import { useEffect, useState } from 'react';
import { useT } from '../../i18n';
import { Button } from '../../components/ui';
import { PromoBanner } from '../../components/membership/PromoBanner';
import { openExternal } from '../../native/bridge';
import type { StoreContractFields } from '../../api/membership';

interface Props {
  contract: (StoreContractFields & { provider?: string | null }) | null | undefined;
  accountKey?: string;
  banner?: boolean;
}
const shown = new Set<string>();
export function BillingIssueNotice({ contract, accountKey, banner = false }: Props) {
  const { t } = useT();
  const [visibleKey, setVisibleKey] = useState<string | null>(null);
  const [dismissed, setDismissed] = useState(false);
  const date = new Date();
  const day = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
  const key = accountKey ? `lorath:billing-issue:${accountKey}:${day}` : null;
  const issue = contract?.billing_issue;
  useEffect(() => {
    if (!banner || !issue || !key || shown.has(key)) return;
    try { if (localStorage.getItem(key)) return; localStorage.setItem(key, '1'); } catch { /* Sitzungs-Cap bleibt wirksam. */ }
    shown.add(key);
    setDismissed(false);
    setVisibleKey(key);
  }, [banner, issue, key]);
  if (!issue || dismissed || (banner && visibleKey !== key)) return null;
  const store = t(contract?.provider === 'apple' ? 'iap.billing_issue.apple_store' : 'iap.billing_issue.google_store');
  const text = t('iap.billing_issue.text', { store });
  const manageUrl = contract?.manage_url ?? (contract?.provider === 'apple'
    ? 'https://apps.apple.com/account/subscriptions' : 'https://play.google.com/store/account/subscriptions');
  const manage = () => { void openExternal(manageUrl); };
  if (banner) return <PromoBanner id="billing-issue" title={t('iap.billing_issue.title')} text={text}
    ctaLabel={t('iap.billing_issue.manage')} onCta={manage} onDismiss={() => setDismissed(true)} />;
  return <section role="status"><p>{text}</p>
    <Button onClick={manage}>{t('iap.billing_issue.manage')}</Button>
    <Button variant="ghost" onClick={() => setDismissed(true)}>{t('promo.dismiss')}</Button>
  </section>;
}
